import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import {
  Formik, Form as FormikForm, FieldArray,
} from 'formik';
import * as Yup from 'yup';

import {
  TextField,
  TextAreaField,
  SubmitButton,
  CancelPopupButton,
} from 'ui/FormElement';
import Document from './Document';

export default function Index({ affiliateTrainingStep, onSave, onHide }) {
  const formSchema = Yup.object().shape({
    title: Yup.string().required('Title is required'),
    documents: Yup.array().of(
      Yup.object().shape({
        id: Yup.string().optional(),
        title: Yup.string().required('required'),
        content_type: Yup.string().required('required').nullable(),
        link: Yup.string().when('content_type', {
          is: (contentType) => contentType === 'link' || contentType === 'video',
          then: Yup.string().required('required'),
        }),
        document: Yup.mixed().when(['id', 'content_type'], {
          is: (id, contentType) => !id && contentType === 'file',
          then: Yup.mixed().required('required'),
        }),
      }),
    ),
  });

  const initialValues = {
    title: affiliateTrainingStep?.attributes?.title || '',
    description: affiliateTrainingStep?.attributes?.description || '',
    documents: affiliateTrainingStep?.attributes?.documents || [],
  };

  const prepareFormData = (values) => {
    const formData = new FormData();

    formData.append('affiliate_training_step[title]', values.title);
    formData.append('affiliate_training_step[description]', values.description);

    values.documents.forEach((item) => {
      formData.append('affiliate_training_step[affiliate_training_step_documents_attributes][][title]', item.title);
      formData.append(
        'affiliate_training_step[affiliate_training_step_documents_attributes][][content_type]',
        item.content_type,
      );

      if (item.id) {
        formData.append('affiliate_training_step[affiliate_training_step_documents_attributes][][id]', item.id);
      }

      if (item.destroy) {
        formData.append('affiliate_training_step[affiliate_training_step_documents_attributes][][_destroy]', true);
      }

      if (item.link) {
        formData.append('affiliate_training_step[affiliate_training_step_documents_attributes][][link]', item.link);
      }

      if (item.document) {
        formData.append(
          'affiliate_training_step[affiliate_training_step_documents_attributes][][document]',
          item.document,
          item.document.name,
        );
      }
    });

    return formData;
  };

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    onSave(
      prepareFormData(values),
      () => {
        setSubmitting(false);
        onHide();
      },
      (errors) => {
        const newErrors = {};
        errors.forEach((item) => {
          if (item.source.pointer) {
            newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
          }
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Formik
      enableReinitialize
      validationSchema={formSchema}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({ isSubmitting, values, setFieldValue }) => (
        <FormikForm className="needs-validation" noValidate="">
          <TextField
            name="title"
            label={(
              <>
                <span>Title</span>
                <abbr title="required">*</abbr>
              </>
            )}
          />

          <TextAreaField
            name="description"
            label={(
              <span>Description</span>
            )}
            style={{ resize: 'vertical' }}
          />

          <FieldArray name="documents">
            {(helpers) => (
              <>
                <h3>Documents</h3>

                {values.documents.length > 0
                  && values.documents.map((item, index) => (
                    <Document
                      key={index}
                      index={index}
                      helpers={helpers}
                      setFieldValue={setFieldValue}
                      record={item}
                    />
                  ))}

                <Button
                  bsStyle="primary"
                  onClick={
                    () => helpers.push({
                      id: undefined,
                      destroy: undefined,
                      title: '',
                      content_type: undefined,
                      link: '',
                      document: undefined,
                    })
                  }
                >
                  Add Document
                </Button>
              </>
            )}
          </FieldArray>

          <div className="text-center mt50 mb30">
            <CancelPopupButton
              title="Cancel"
              className="btn btn-primary btn-outline mr5 ml5 width-120"
              onClick={onHide}
            />

            <SubmitButton
              title={isSubmitting ? 'Please, wait ...' : 'Save'}
              style={{ width: '120px' }}
            />
          </div>
        </FormikForm>
      )}
    </Formik>
  );
}

Index.propTypes = {
  affiliateTrainingStep: PropTypes.object,
  onSave: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};

Index.defaultProps = {
  affiliateTrainingStep: {},
};
